import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { BrokersListContainer } from './containers/brokers-list/brokers-list.container';

export const BrokerModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.BROKER_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.BROKER_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.BROKER_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={BrokersListContainer}
      />
    </>
  );
};
